// src/contexts/PermissionContext.js
import React, { createContext, useContext, useMemo } from 'react';
import { checkPermission, getModuleOperations, getUserObj } from '../utils';

const PermissionContext = createContext();

export const PermissionProvider = ({ children }) => {
    const userObj = getUserObj()
    const permission = userObj?.permissions
    const contextValue = useMemo(() => ({ checkPermission, getModuleOperations }), [permission]);

    return (
        <PermissionContext.Provider value={contextValue}>
            {children}
        </PermissionContext.Provider>
    );
};

export const usePermission = () => {
    return useContext(PermissionContext);
};
